<template>
  <div
    class="modal__cover text-modal--with-secondary"
    @click.self="onClickModalCover"
  >
    <div class="modal__content">
      <div
        class="modal__descriptions"
        :class="{ 'without-cancel-description': !showCancelButton }"
      >
        <div class="modal__text">
          <div class="modal__text__title">
            <span>{{ titleText }}</span>
          </div>
          <div v-if="showCaption" class="modal__text__caption">
            <span>{{ captionText }}</span>
          </div>
        </div>
        <div class="modal__btn">
          <div class="modal__btn--primary">
            <button
              type="button"
              class="btn btn--primary"
              style="margin: 0;"
              :disabled="primaryButtonDisabled || null"
              @click="onClickPrimaryButton"
            >
              {{ primaryButtonText }}
            </button>
          </div>
          <div class="modal__btn--secondary">
            <button
              type="button"
              class="btn btn--secondary"
              :disabled="secondaryButtonDisabled || null"
              @click="onClickSecondaryButton"
            >
              {{ secondaryButtonText }}
            </button>
          </div>
          <div v-if="showCancelButton" class="modal__btn--cancel">
            <span @click="onClickCancelButton">{{ cancelButtonText }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    titleText: {
      type: String,
      required: true
    },
    captionText: {
      type: String,
      required: false,
      default: ''
    },
    primaryButtonText: {
      type: String,
      required: true
    },
    secondaryButtonText: {
      type: String,
      required: true
    },
    cancelButtonText: {
      type: String,
      required: false,
      default: ''
    },
    primaryButtonDisabled: {
      type: Boolean,
      required: false,
      default: false
    },
    secondaryButtonDisabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    showCaption() {
      return this.captionText !== ''
    },
    showCancelButton() {
      return this.cancelButtonText !== ''
    }
  },
  methods: {
    onClickModalCover() {
      this.$emit('clicked-modal-cover')
    },
    onClickPrimaryButton() {
      this.$emit('clicked-primary')
    },
    onClickSecondaryButton() {
      this.$emit('clicked-secondary')
    },
    onClickCancelButton() {
      this.$emit('clicked-cancel')
    }
  }
}
</script>

<style lang="scss" scoped>
.without-cancel-description {
  padding-top: 32px;
  padding-bottom: 54px;
}
</style>
